const actionTypes = {
  SET_USER: "SET_USER",
  SET_USER_PANLESS_HOLDINGS: "SET_USER_PANLESS_HOLDINGS",
  SET_PAN_ONBOARDING: "SET_PAN_ONBOARDING",
  SET_SHOW_ONBOARDING: "SET_SHOW_ONBOARDING",
  SET_CURRENT_ONBOARDING_STEP: "SET_CURRENT_ONBOARDING_STEP",
  SET_CURRENT_ACCOUNT_ONBOARDING_STAGE: "SET_CURRENT_ACCOUNT_ONBOARDING_STAGE",
  SET_ONBOARDING_DATA_ADD_PAN: "SET_ONBOARDING_DATA_ADD_PAN",
  SET_ONBOARDING_DATA_KYC_VERIFICATION_STATUS: "SET_ONBOARDING_DATA_KYC_VERIFICATION_STATUS",
  SET_ONBOARDING_DATA_KYC_DETAILS: "SET_ONBOARDING_DATA_KYC_DETAILS",
  SET_ONBOARDING_DATA_KYC_CONTACT: "SET_ONBOARDING_DATA_KYC_CONTACT",
  SET_ONBOARDING_KYC_DETAILS: "SET_ONBOARDING_KYC_DETAILS",
  SET_ONBOARDING_FLOW_TYPE: "SET_ONBOARDING_FLOW_TYPE",
  SET_ONBOARDING_PAN: "SET_ONBOARDING_PAN",
  SET_NEWS: "SET_NEWS",
  SET_BLOG: "SET_BLOG",
  SET_TRENDING_FUNDS: "SET_TRENDING_FUNDS",
  SET_TOP_PICKS: "SET_TOP_PICKS",
  SET_PORTFOLIO: "SET_PORTFOLIO",
  CLEAR_PORTFOLIO: "CLEAR_PORTFOLIO",
  SET_SIPS: "SET_SIPS",
  SET_TRANSACTIONS: "SET_TRANSACTIONS",
  SET_PRICING_PLANS: "SET_PRICING_PLANS",
  SET_CURRENT_PLAN: "SET_CURRENT_PLAN",
  SET_WALLET_DATA: "SET_WALLET_DATA",
  SET_BROWSE_FUNDS_DATA: "SET_BROWSE_FUNDS_DATA",
  SET_BROWSE_CURRENT_FILTERS: "SET_BROWSE_CURRENT_FILTERS",
  SET_BROWSE_SORT_OPTION: "SET_BROWSE_SORT_OPTION",
  SET_CART_COUNTS: "SET_CART_COUNTS",
  CLEAR_ONBOARDING_DATA: "CLEAR_ONBOARDING_DATA",
  RESET_STORE: "RESET_STORE",
  SET_GOALS_LIST: "SET_GOALS_LIST",
  SET_GOAL_SETUP_DATA: "SET_GOAL_SETUP_DATA",
  SET_BSE: "SET_BSE",
  SET_TOKEN: "SET_TOKEN",
  SET_SESSION_TOKEN: "SET_SESSION_TOKEN",
  SET_BASKETS: "SET_BASKETS",
  SET_PUBLIC_KEY: "SET_PUBLIC_KEY",
  SET_ICICI_CART: "SET_ICICI_CART",
  SET_SHOPPING_GOALS: "SET_SHOPPING_GOALS",
  SET_AMAZON_GOAL_DATA: "SET_AMAZON_GOAL_DATA",
  SET_APP_CONFIG: "SET_APP_CONFIG",
  SET_RISK_PROFILER: "SET_RISK_PROFILER",
  SET_USER_ESIGN_STATE: "SET_USER_ESIGN_STATE",
  SET_USER_TRANSACTION_STATE: "SET_USER_TRANSACTION_STATE",
  SET_NSDL_PDF_ANALYSER: "SET_NSDL_PDF_ANALYSER",
  GET_OROBONDS_TPD: "GET_OROBONDS_TPD"
};

export default actionTypes;
